<template>
  <div class="product">
     <header>
    <Navbar />
    </header>
    <div class="product-header">
     
      <div class="product_bannnerText">
        <div>智慧互联</div>
        <div>
          基于新一代的信息技术，在云计算、物联网、大数据应用、移动医疗和医疗社交化应用方面开展应用实践，实现医疗卫生事业的可持续发展，带动相关产业的发展。
        </div>
      </div>
    </div>
    <div class="productCont">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right;">
          <el-breadcrumb-item :to="{ path: '/productCenter' }"
            >产品中心 > 智慧互联 ></el-breadcrumb-item
          >
          <el-breadcrumb-item v-show="current===1">集成平台</el-breadcrumb-item>
          <el-breadcrumb-item v-show="current===2">数据中心</el-breadcrumb-item>
          <el-breadcrumb-item v-show="current===3">互联网医院</el-breadcrumb-item>
          <el-breadcrumb-item v-show="current===4">区域卫生平台</el-breadcrumb-item>
          <el-breadcrumb-item v-show="current===5">区域医院信息系统</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="tabs" style="background-color: #ffffff">
        <div class="tabsCont">
          <el-radio-group v-model="tabPosition" style="margin-bottom: 30px">
          </el-radio-group>

          <div class="tabTitle">
            <div>产品导航</div>
            <div>智慧互联产品体系</div>
          </div>
          <el-tabs :tab-position="tabPosition" >
            <el-tab-pane >
             <span slot="label" @click="tab(1)">
                <i class="el-icon-caret-right"></i> 集成平台
             </span >
              <div class="outpatient">
                <div class="outpatientTitle">集成平台</div>
                <div class="outpatientCont">
                  <div class="outpatientConBox">
                    <div class="intro">集成平台简介</div>
                    <div class="outpatientContText">
                      展华科技为满足当前医院信息化建设需求，结合最新版的互联互通评测标准，以及多年来在医疗卫生领域的行业积累，在总线技术基础上，推出了基于微服务架构的集成平台。平台以信息采集、存储、交换和集中管理为核心功能，实现医院内部不同业务信息系统之间的统一集成、互联互通、业务协同、信息整合和信息共享，并支持跨机构医疗信息共享和业务监管，支持与上级平台实现可靠的信息交换(包括电子健康档案、电子病历等信息交换共享和跨机构医疗业务协同)。
                      <br />展华集成平台通过ESB和RocketMQ，提供服务的注册、发布、服务编排等功能，支持Socket、WebService、Http和MQ等接消息接入方式，消息格式支持Hl7
                      v2/v3/CDA/Fhir协议，同时也支持xml、Json等自定义消息格式。
                    </div>
                    <div class="outpatientImg">
                      <img :src="smartIntera" />
                      <div class="line">— 集成平台系统截图 —</div>
                    </div>
                  </div>
                  <div class="outpatientConBox">
                    <div class="outpatientContTitle">系统主要特点</div>
                    <div class="trait">
                      <li>规范性</li>
                      <li>安全性</li>
                      <li>高可用性</li>
                      <li>可靠性</li>
                      <li>易用性</li>
                    </div>
                  </div>
                </div>
                <div></div>
              </div>
            </el-tab-pane>
            <el-tab-pane
              ><span slot="label" @click="tab(2)"
                ><i class="el-icon-caret-right"></i> 数据中心</span
              >
              <div class="outpatient">
                <div class="outpatientTitle">数据中心</div>
                <div class="outpatientCont">
                  <div class="outpatientConBox">
                    <div class="intro">数据中心简介</div>
                    <div class="outpatientContText">
                      数据中心在基于电子病历的医院信息平台中主要扮演信息资源层的角色，用于平台各类数据的存储、处理和管理。各个业务系统产生的信息，通过集成平台标准化转换后，在数据中心进行整合，并以此形成电子病历信息、运营业务信息，同时将临床知识库、药学知识库等集成到临床数据中心，提高医院的信息化应用水平。
                      <br />
                      数据中心为临床数据中心、运营数据中心、科研数据中心提供数据建模服务,
                      为医院的各类信息化应用提供一个统一的、完整的数据集合，在此基础上实现医疗业务信息、医疗管理运营信息和科研信息的应用管理，最终实现辅助改善医疗服务质量、减少医疗差错、提高临床科研水平和降低医疗成本等目标。
                    </div>
                    <div class="outpatientImg">
                      <img :src="smartInterb" />
                      <div class="line">— 数据中心系统截图 —</div>
                    </div>
                  </div>
                  <div class="outpatientConBox">
                    <div class="outpatientContTitle">系统主要特点</div>
                    <div class="trait">
                      <li>电子病历阅览器</li>
                      <li>患者全息视图</li>
                      <li>临床辅助决策</li>
                      <li>管理辅助决策</li>
                      <li>临床科研支持</li>
                      <li>医嘱闭环管理</li>
                    </div>
                  </div>
                </div>
                <div></div></div
            ></el-tab-pane>
            <el-tab-pane>
              <span slot="label" @click="tab(3)">
                <i class="el-icon-caret-right"></i> 互联网医院
              </span>
              <div class="outpatient">
                <div class="outpatientTitle">互联网医院</div>
                <div class="outpatientCont">
                  <div class="outpatientConBox">
                    <div class="intro">互联网医院简介</div>
                    <div class="outpatientContText">
                      根据卫健委颁布的《互联网诊疗管理办法（试行）》、《互联网医院管理办法（试行）》，在实体医院基础上，运用互联网、云计算、大数据等技术提供安全适宜的医疗信息技术服务，建设以在线复诊、在线处方为核心业务的互联网诊疗系统。
                      <br />通过建立“在线预约-线上复诊-线上缴费-在线处方-药品配送”闭环的模式，帮助患者建立在线就诊、快速购药通道，减轻线下就医困难。
                    </div>
                  </div>
                  <div class="outpatientConBox">
                    <div class="outpatientContTitle">系统主要功能</div>
                    <li>
                      <span>互联网医院-移动终端</span>
                    </li>
                    <div class="outpatientImg">
                      <img :src="smartInterc" />
                    </div>
                    <li style="margin-top: 30px">
                      <span>互联网医院-院内系统</span>
                      <div class="nursing">
                        主要导诊系统、医生接诊系统、数据访问控制系统、服务监管平台对接等功能。
                      </div>
                    </li>
                  </div>
                  <div class="outpatientConBox">
                    <div class="outpatientContTitle">系统主要功能</div>
                    <li>
                      <span>新建设：</span
                      >依托实体医院建设，医院主导，符合卫健委互联网医院建设要求。
                    </li>
                    <li>
                      <span>更便利：</span
                      >与院内各业务系统保持数据同步，快速部署，方便使用，简单易用，快速上手。
                    </li>
                    <li>
                      <span>更全面：</span
                      >视频接诊，全程留痕，扩展应用，持续更新。
                    </li>
                  </div>
                </div>
                <div></div></div
            ></el-tab-pane>
            <el-tab-pane style="height:660px">
              <span slot="label" @click="tab(4)">
                <i class="el-icon-caret-right"></i> 区域卫生平台
              </span>
              <div class="outpatient">
                <div class="outpatientTitle">区域卫生平台</div>
                <div class="outpatientCont">
                  <div class="outpatientConBox">
                    <div class="intro">区域卫生平台简介</div>
                    <div class="outpatientContText">
                      展华区域卫生平台建设，坚持以人为中心，以问题为导向，以改善医疗服务质量、效率和可及性为出发点，以提升管理、服务能力为目标，通过优化流程、提升质量、保障安全、促进沟通等措施，为人民群众提供安全、有效、方便的基本医疗服务，为医务人员提供高效的服务工具，为各级管理人员提供强有力的管理手段。
                      <br />
                      展华区域卫生平台基于新一代的信息技术，在云计算、物联网、大数据应用、移动医疗和医疗社交化应用方面开展应用实践，推动区域分级诊疗体系发展、改善医疗保障体系，提升药品监管能力，增强卫生决策指挥能力，改进医患关系，实现医疗卫生事业的可持续发展，带动相关产业的发展，促进区域健康发展。
                    </div>
                  </div>
                  <div class="outpatientConBox">
                    <div class="outpatientContTitle">系统主要功能</div>
                    <div class="trait">
                      <li>远程会诊</li>
                      <li>远程影像诊断</li>
                      <li>远程心电诊断</li>
                      <li>远程病理诊断</li>
                      <li>双向转诊</li>
                      <li>远程医学教育</li>
                      <li>区域医疗数据监控</li>
                    </div>
                  </div>
                </div>
                <div></div>
              </div>
            </el-tab-pane>
            <el-tab-pane style="height:660px">
              <span slot="label" @click="tab(5)">
                <i class="el-icon-caret-right"></i> 区域医院信息系统
              </span>
              <div class="outpatient">
                <div class="outpatientTitle">区域医院信息系统</div>
                <div class="outpatientCont">
                  <div class="outpatientConBox">
                    <div class="intro">区域医院信息系统简介</div>
                    <div class="outpatientContText">
                      区域内的医院、社区卫生服务中心（站）、乡镇卫生院共用同一个信息系统，将县（市、区）内的基层医疗卫生机构的医疗信息数据集中在县（市、区）级平台上，对区域内的医院、社区卫生服务中心（站）、乡镇卫生院进行统一管理。
                      <br />系统采用 B/S
                      架构建设，具备内嵌的统一用户身份认证和授权管理功能，访问控制功能可以确保对数据访问的随需控制，不仅支持普通的列级访问控制，还支持行级访问控制。授权管理体系支持逐级转授权，支持将系统管理和使用权限下发，使得业务人员真正成为数据的控制者。
                    </div>
                  </div>
                  <div class="outpatientConBox">
                    <div class="outpatientContTitle">系统主要功能</div>
                    <div class="traits">
                      <li>药品管理系统</li>
                      <li>住院收费系统</li>
                      <li>社区收费药房系统</li>
                      <li>门诊医生工作站系统</li>
                      <li>住院医生工作站系统</li>
                      <!-- </div>
                       <div class="trait"> -->
                      <li>门诊皮试系统</li>
                      <li>院长查询分析系统</li>
                      <li>医疗保险管理系统</li>
                      <li>门急诊挂号收费系统</li>
                      <li>住院护士工作站系统</li>
                    </div>
                  </div>
                </div>
                <div></div></div
            ></el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </div>
    <footer>
    <Root/>
    </footer>
  </div>
</template>
<script src="//unpkg.com/vue/dist/vue.js"></script>
<script src="//unpkg.com/element-ui@2.15.7/lib/index.js"></script>
<script>
import Navbar from "../../layout/Navbar.vue";
import Root from "../../layout/root.vue"
import interBanner from "../../assets/interBanner.png";
import smartIntera from "../../assets/smartIntera.png";
import smartInterb from "../../assets/smartInterb.png";
import smartInterc from "../../assets/smartInterc.png";
export default {
  name: "inter",
  components: {
    Navbar,
    Root,
  },
  data() {
    return {
      current:1,
      tabPosition: "left",
      interBanner: interBanner,
      smartIntera: smartIntera,
      smartInterb: smartInterb,
      smartInterc: smartInterc,
    };
  },
  methods: {
     tab(index){
      this.current=index;
    },
  },
};
</script>
<style scoped>
@import url("//unpkg.com/element-ui@2.15.7/lib/theme-chalk/index.css");
footer{
  height: 520px;
  margin-top: 30px;
}
header{
 background-color: #ffffff;
}
.product {
  background-color: #f5f7fa;
  width: 100%;
  overflow: hidden;

  font-family: PingFangSC-Medium;
}
.product-header {
  position: relative;
  height: 420px;
  width: 100%;
  margin: 0 auto;
  background: url("../../assets/interBanner.png") no-repeat;
  background-size: cover;
  background-position:center;
}
/* .productBanner {
  width: 1920px;
  left: 50%;
  margin-left: -960px;
  position: relative;
} */

.product_bannnerText {
  position: absolute;
  left: 7.5%;
  top: 113px;
}
.product_bannnerText :nth-child(1) {
  font-size: 52px;
  color: #0f1422;
  letter-spacing: 0;
  font-weight: 500;
}
.product_bannnerText :nth-child(2) {
  width: 64%;
  font-size: 18px;
  color: #3d455f;
  letter-spacing: 0;
  line-height: 28px;
  font-weight: 200;
  margin-top: 33px;
}
.productCont {
  width: 85%;
  margin: 0 auto;
}
.crumbs {
  margin-top: 25px;
  margin-bottom: 30px;
}
.crumbs .el-breadcrumb {
  font-size: 16px;
  color: #3d455f;
  letter-spacing: 0;
  line-height: 22px;
  font-weight: 400;
}
.tabsCont {
  width: 95%;
  margin: 0 auto;
  position: relative;
}
.tabTitle {
  position: absolute;
  top: 35px;
  z-index: 100;
  width: 20%;
}
.tabTitle :nth-child(1) {
  font-size: 20px;
  margin: 0 auto;
  height: 50px;
  border-bottom: 1px solid #e9eaee;
  color: #0f1422;
  letter-spacing: 0;
  font-weight: 500;
}
.tabTitle :nth-child(2) {
  font-size: 16px;
  color: #0f1422;
  letter-spacing: 0;
  margin-top: 20px;
  font-weight: 500;
  margin-bottom: 20px;
}
.outpatient {
  width: 90%;
  margin: 0 auto;
}
.outpatientTitle {
  font-size: 28px;
  color: #0f1422;
  letter-spacing: 0;
  font-weight: 500;
  height: 55px;
  border-bottom: 1px solid #e9eaee;
}
.outpatientConBox {
  width: 100%;
  margin: 0 auto;
}
.outpatientImg {
  width: 100%;
  text-align: center;

  margin: 0 auto;
}
.outpatientImg img {
  margin-top: 50px;
}
.tabs .el-tabs {
  height: 100% !important;
}
.outpatientContTitle {
  font-size: 20px;
  color: #0f1422;
  letter-spacing: 0;
  font-weight: 500;
  margin-top: 50px;
  margin-bottom: 28px;
}
.outpatientContText {
  font-size: 16px;
  color: #3d455f;
  letter-spacing: 0;
  text-align: justify;
  line-height: 26px;
  font-weight: 400;
  margin-top: 20px;
}
.intro {
  font-size: 20px;
  color: #0f1422;
  letter-spacing: 0;
  font-weight: 500;
  margin-top: 66px;
  margin-bottom: 28px;
}
.a {
  position: relative;
  z-index: 1;
}
.el-icon-caret-right {
  color: #ffffff;
  margin-left: -20px;
}
.outpatientImg .line {
  font-size: 14px;
  color: #767b8d;
  letter-spacing: 0;
  text-align: center;
  line-height: 26px;
  font-weight: 200;
  margin-top: 10px;
}
.outpatientConBox li {
  font-size: 16px;
  margin-bottom: 16px;
  /* margin-top: 30px; */
  color: #3d455f;
  letter-spacing: 0;
  font-weight: 400;
}
.outpatientConBox li span {
  color: #0f1422;
  font-weight: 500;
}
.trait {
  display: flex;
  flex-wrap: wrap;
  font-size: 16px;
  color: #3d455f;
  letter-spacing: 0;
  text-align: justify;
  font-weight: 400;
justify-content: space-between 
}
.traits {
  display: flex;
  flex-wrap: wrap;
  font-size: 16px;
  color: #3d455f;
  letter-spacing: 0;
  text-align: justify;
  font-weight: 400;
  /* justify-content: flex-start; */
  /* justify-content: space-around; */
  justify-content: space-between;
}
/* .trait:after {content: ""; width: 20%; }  */
.traits:after {content: ""; width: 50%; }  
.traits li {
  width: 20%;
}
.nursing {
  text-indent: 1em;
  font-size: 16px;
  color: #3d455f;
  letter-spacing: 0;
  line-height: 26px;
  font-weight: 400;
  margin-top: 16px;
}
.nursing span {
  color: #29324c;
}
.tabsCont >>> .el-tabs__header {
  /* width: 22% !important; */
  background-color: #ffffff;
  padding-top: 120px;
}
.tabsCont >>> .el-tabs__content {
  border-left: #f5f7fa 8px solid;

  background-color: #ffffff;
}
.tabsCont >>> .el-radio-group {
  margin: 0;
}
.tabsCont >>> .el-tabs__item {
  text-align: left;
  font-size: 16px;
  color: #0f1422;
  letter-spacing: 0;
  width: 95%;
  font-weight: 400;
}
.tabsCont >>> .el-tabs__item.is-active {
  text-align: left;
  font-size: 16px;
  background-color: #e52f22;
  color: #ffffff;
  width: 95%;
  letter-spacing: 0;
  font-weight: 500;
}
.tabsCont >>> .el-tabs__item {
text-align: left  !important;
}

</style>



// WEBPACK FOOTER //
// src/views/inter/index.vue